function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_badge_not_tested",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#878787",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("g", {
  id: "assets/icons/ic_not_tested",
  transform: "translate(4.000000, 2.000000)"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 40,
  height: 24
}), React.createElement("path", {
  d: "M21.09538,19.533532 C21.9299553,19.533532 22.4307004,19.1162444 22.5976155,18.2295082 L23.1609538,15.4545455 L24.4754098,15.4545455 C25.4560358,15.4545455 26.0506706,14.880775 26.0506706,13.9836066 C26.0506706,13.2742176 25.5603577,12.8152012 24.7675112,12.8152012 L23.6721311,12.8152012 L24.1207154,10.509687 L25.4351714,10.509687 C26.4157973,10.509687 27,9.93591654 27,9.04918033 C27,8.33979136 26.5201192,7.89120715 25.7168405,7.89120715 L24.6423249,7.89120715 L25.1013413,5.60655738 C25.1326379,5.4709389 25.14307,5.27272727 25.14307,5.13710879 C25.14307,4.4485842 24.6944858,4 23.9225037,4 C23.0879285,4 22.5871833,4.41728763 22.4202683,5.30402385 L21.8986587,7.89120715 L19.561848,7.89120715 L20.0104322,5.60655738 C20.0417288,5.4709389 20.0625931,5.27272727 20.0625931,5.13710879 C20.0625931,4.4485842 19.6035768,4 18.8315946,4 C17.9970194,4 17.4962742,4.41728763 17.3293592,5.30402385 L16.7973174,7.89120715 L15.514158,7.89120715 C14.533532,7.89120715 13.9388972,8.46497765 13.9388972,9.36214605 C13.9388972,10.0611028 14.4292101,10.5305514 15.2220566,10.5305514 L16.2861401,10.5305514 L15.8375559,12.8360656 L14.5648286,12.8360656 C13.5842027,12.8360656 13,13.4098361 13,14.2965723 C13,15.0059613 13.4798808,15.4545455 14.2831595,15.4545455 L15.3159463,15.4545455 L14.8256334,17.9269747 C14.7943368,18.0625931 14.7839046,18.2608048 14.7839046,18.3964232 C14.7839046,19.0849478 15.2324888,19.533532 16.0044709,19.533532 C16.8390462,19.533532 17.3397914,19.1162444 17.5067064,18.2399404 L18.0596125,15.4545455 L20.4172876,15.4545455 L19.9165425,17.9269747 C19.8852459,18.0625931 19.8748137,18.2608048 19.8748137,18.3964232 C19.8748137,19.0849478 20.3233979,19.533532 21.09538,19.533532 Z M21.0745156,13.0968703 L18.2995529,13.0968703 L18.8733234,10.2384501 L21.6587183,10.2384501 L21.0745156,13.0968703 Z",
  id: "#",
  fill: "#FFFFFF",
  fillRule: "evenodd"
})));

const SvgIcBadgeNotTested = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcBadgeNotTested, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_badge_not_tested.fadd0c87.svg";
export { ForwardRef as ReactComponent };